module.exports = __webpack_public_path__ + "static/media/gn.b988a2c2.svg";